module.exports = new __parcel__URL__("screenshot.0b48a42e.png").toString();